 
 
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MaintenanceState, SaveMaintenanceRequest } from '../../actions/types/schedule-maintenance/SaveMaintenanceTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: MaintenanceState = {
  isLoading: false,
  isTrackerLoading: true,
  iseventDetailsLoading: true,
  success: false,
  errorMessage: '',
  saveMaintenanceDetails: []
};

/**
 * get metric summary Slice to get metric
 */
export const saveMaintenanceSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    saveMaintenanceStarted: (state) => {
      state.isLoading = true;
    },

    saveMaintenanceSuccess: (state, action: PayloadAction<SaveMaintenanceRequest[]>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.saveMaintenanceDetails = action.payload;
    },

    saveMaintenanceFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.saveMaintenanceDetails = initialState.saveMaintenanceDetails;
    },

    clearSaveMaintenance: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.saveMaintenanceDetails = initialState.saveMaintenanceDetails;
    }
  }
});

export const {
  saveMaintenanceStarted,
  saveMaintenanceSuccess,
  saveMaintenanceFail,
  clearSaveMaintenance
} = saveMaintenanceSlice.actions;
export default saveMaintenanceSlice.reducer;
